import _toConsumableArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { BREAKPOINTS, BreakpointKeys } from "../constants/breakpoints";
import { css } from 'styled-components';
import { useMedia } from 'react-use';
var breakpointKeyValues = Object.values(BreakpointKeys);
var mediaQueries = breakpointKeyValues.reduce(function (accumulator, label) {
  var breakpoint = BREAKPOINTS[label];
  accumulator[label] = function (literals) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return css(["@media (min-width:", "px){", "}"], breakpoint, css.apply(void 0, [literals].concat(args)));
  };
  return accumulator;
}, {});
export var mediaQueriesDown = breakpointKeyValues.reduce(function (accumulator, label) {
  var breakpoint = BREAKPOINTS[label];
  accumulator[label] = function (literals) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return css(["@media (max-width:", "px){", "}"], breakpoint - 1, css.apply(void 0, [literals].concat(args)));
  };
  return accumulator;
}, {});

/**
 * React hook that uses useMedia hook to return a break point config object with matched breakpoints set to true otherwise false
 *
 * @param {Object} defaultStates Default states to pass useMedia hook
 * @param {Object} defaultStates.xl Default state for lg media query
 * @param {Object} defaultStates.lg Default state for lg media query
 * @param {Object} defaultStates.md Default state for md media query
 * @param {Object} defaultStates.sm Default state for sm media query
 * @param {Object} defaultStates.xs Default state for xs media query
 * @returns {{ lg: Boolean, md: Boolean, sm: Boolean, xs: Boolean, base: Boolean }}
 */
export var useMatchedBreakpoints = function useMatchedBreakpoints() {
  var defaultStates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    xl: useMedia("(min-width: ".concat(BREAKPOINTS.xl, "px)"), defaultStates === null || defaultStates === void 0 ? void 0 : defaultStates.xl),
    lg: useMedia("(min-width: ".concat(BREAKPOINTS.lg, "px)"), defaultStates === null || defaultStates === void 0 ? void 0 : defaultStates.lg),
    md: useMedia("(min-width: ".concat(BREAKPOINTS.md, "px)"), defaultStates === null || defaultStates === void 0 ? void 0 : defaultStates.md),
    sm: useMedia("(min-width: ".concat(BREAKPOINTS.sm, "px)"), defaultStates === null || defaultStates === void 0 ? void 0 : defaultStates.sm),
    xs: useMedia("(min-width: ".concat(BREAKPOINTS.xs, "px)"), defaultStates === null || defaultStates === void 0 ? void 0 : defaultStates.xs),
    base: true
  };
};

/**
 * Accepts a breakpoints config, iterates over them and applies css template string by calling template literal tags with the matched config
 */
export var cssForBreakpointsConfig = function cssForBreakpointsConfig(breakpointsConfig) {
  return function (templateString) {
    for (var _len3 = arguments.length, templateStringTags = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      templateStringTags[_key3 - 1] = arguments[_key3];
    }
    return breakpointKeyValues.filter(function (breakpoint) {
      return !!breakpointsConfig[breakpoint];
    }).map(function (breakpoint) {
      var config = breakpointsConfig[breakpoint];
      var templateStringTagsWithConfig = templateStringTags.map(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      function (literalArg) {
        return function (props) {
          return literalArg(config, props);
        };
      });
      if (breakpoint === 'base') {
        return css(templateString, templateStringTagsWithConfig);
      }
      return mediaQueries[breakpoint].apply(mediaQueries, [templateString].concat(_toConsumableArray(templateStringTagsWithConfig)));
    });
  };
};
export default mediaQueries;